import { Component, ElementRef, EventEmitter, Input, OnChanges, Output, SimpleChanges, ViewChild, signal } from '@angular/core'
import { comprimirImagen } from '../../infrastructure/util/comprimir-imagen'
import { VisorImagenComponent } from './visor-imagen'

/**
 * Delegamos la captura a la cámara nativa del teléfono (input file + capture),
 * no a una cámara casera dentro de la web. Antes había también una vista en
 * vivo hecha a mano (getUserMedia + <video>), pero sin autoenfoque ni zoom
 * reales termina siendo peor que la cámara del sistema — Angie reportó
 * exactamente eso ("no enfoca", "no me deja hacer zoom"). Se quitó del todo
 * para no dejar dos caminos confusos; este input ya delegaba a la cámara real
 * como respaldo, ahora es el único camino.
 */
let siguienteInputArchivoId = 0

@Component({
  selector: 'app-camara-captura',
  standalone: true,
  imports: [VisorImagenComponent],
  templateUrl: './camara-captura.html',
})
export class CamaraCapturaComponent implements OnChanges {
  @Input({ required: true }) etiqueta!: string
  @Input() fotoPreviaUrl?: string
  @Output() foto = new EventEmitter<Blob>()

  @ViewChild('inputArchivo') inputArchivoRef?: ElementRef<HTMLInputElement>

  readonly preview = signal<string | undefined>(undefined)
  readonly archivoInputId = `camara-archivo-${siguienteInputArchivoId++}`

  /** Ver en grande la foto ya tomada — pedido desde la feria, 2026-09-06. */
  readonly verAmpliada = signal(false)

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['fotoPreviaUrl']) this.preview.set(this.fotoPreviaUrl)
  }

  async alSeleccionarArchivo(e: Event): Promise<void> {
    const archivo = (e.target as HTMLInputElement).files?.[0]
    if (!archivo) return
    const comprimido = await comprimirImagen(archivo)
    this.preview.set(URL.createObjectURL(comprimido))
    this.foto.emit(comprimido)
  }

  /** Limpiamos el preview y reabrimos el picker nativo para no exigir un toque extra. */
  repetirFoto(): void {
    this.preview.set(undefined)
    this.inputArchivoRef?.nativeElement.click()
  }

  abrirAmpliada(): void {
    if (this.preview()) this.verAmpliada.set(true)
  }

  cerrarAmpliada(): void {
    this.verAmpliada.set(false)
  }
}

